import React from "react";
import { B2bLandingPage } from "./B2bLandingPage";
import { KakaoLandingPage } from "./KakaoLadingPage";
import useNav from "hooks/useNav";
import styles from "./style.module.css";

export default function Page() {
  const { getParams } = useNav();
  const params = getParams<{ code?: string }>();
  const { code } = params;

  if (code === "b2b") {
    return <B2bLandingPage {...params} />;
  } else if (code === "kakao") {
    return <KakaoLandingPage {...params} />;
  }

  return (
    <div className={styles.errWrap}>
      <h1>정상적인 접근이 아닙니다.</h1>
    </div>
  );
}
